function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames'; // import $ from 'kz-jquery';

import KZUIComponent from '../base/index';
import Portal from '../Portal';
import { css, outerWidth } from '../utils';
import './style.less';

var Tooltip = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Tooltip, _KZUIComponent);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    _this.attachedDom = null;

    _this.autoBind('handleBlur', 'handleClick', 'handleMouseOver', 'handleMouseOut', 'getTooltip', 'handlePortalRender', 'fixPosition', 'handleFocus');

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBlur, false);
      this.attachedDom = findDOMNode(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBlur, false);
    }
  }, {
    key: "handlePortalRender",
    value: function handlePortalRender() {
      if (this.state.show) {
        this.fixPosition();
      }
    }
  }, {
    key: "fixPosition",
    value: function fixPosition() {
      var rectObject = this.attachedDom.getBoundingClientRect();
      var x = rectObject.x,
          y = rectObject.y,
          width = rectObject.width,
          height = rectObject.height;
      var tooltipWidth = outerWidth(this.tooltip);
      css(this.tooltip, {
        left: "".concat(x - tooltipWidth / 2 + width / 2, "px"),
        top: "".concat(y + height + 7, "px")
      });
    }
  }, {
    key: "getTooltip",
    value: function getTooltip() {
      var _this2 = this;

      var clsPrefix = 'kui-tooltip';
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var cls = classNames(clsPrefix, className);
      var tip = this.props.tip;
      return /*#__PURE__*/React.createElement(Portal, {
        didMount: this.handlePortalRender
      }, /*#__PURE__*/React.createElement("div", {
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        className: cls,
        style: style,
        ref: function ref(dom) {
          _this2.tooltip = dom;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--triangle")
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--content")
      }, tip)));
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.trigger !== 'click' && this.props.trigger !== 'focus') return;
      if (!this.tooltip) return;

      if (this.tooltip.contains(e.target) || this.attachedDom.contains(e.target)) {
        return;
      }

      this.setState({
        show: false
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (this.props.trigger !== 'focus') return;
      this.setState({
        show: true
      });
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver() {
      if (this.props.trigger !== 'hover') return;
      this.setState({
        show: true
      });
    }
  }, {
    key: "handleMouseOut",
    value: function handleMouseOut() {
      if (this.props.trigger !== 'hover') return;
      this.setState({
        show: false
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.props.trigger !== 'click') return;
      this.setState({
        show: !this.state.show
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var show = this.state.show;
      var child = React.Children.only(children);
      var newProps = {
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        onClick: this.handleClick,
        onFocus: this.handleFocus
      };
      var newChild = React.cloneElement(child, newProps);
      return /*#__PURE__*/React.createElement(React.Fragment, null, newChild, show && this.getTooltip());
    }
  }]);

  return Tooltip;
}(KZUIComponent);

Tooltip.defaultProps = {
  trigger: 'hover',
  children: null
};
Tooltip.propTypes = {
  trigger: PropTypes.string,
  onCancel: PropTypes.func,
  children: PropTypes.node
};
export default Tooltip;